import { useHistory } from 'react-router';

import { useDefaultRedirectRoute } from './useDefaultRedirectRoute';

const useHistoryGoBack = () => {
  const history = useHistory();

  const defaultUrl = useDefaultRedirectRoute();

  const goBack = () => {
    if (history.length === 1) {
      history.replace(defaultUrl);
      return;
    }
    history.goBack();
  };

  return {
    goBack,
  };
};

export default useHistoryGoBack;
